import { render } from "./section-four.vue?vue&type=template&id=d36abac2"
import script from "./section-four.vue?vue&type=script&lang=js"
export * from "./section-four.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__